// extracted by mini-css-extract-plugin
export default {"page-not-found":"PageNotFound_page-not-found__pfcbD","link":"PageNotFound_link__XNRN3","title":"PageNotFound_title__ow6s5","message":"PageNotFound_message__z++Qh"};